import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  headers: { 'Content-Type': 'application/json' },
});

// Types for registration options
export interface RegistrationOption {
  value: string;
  label: string;
}

export interface RegistrationOptions {
  sex_options: RegistrationOption[];
  native_language_options: RegistrationOption[];
  english_level_options: RegistrationOption[];
  english_exposure_options: RegistrationOption[];
  daily_writing_options: RegistrationOption[];
  education_levels: RegistrationOption[];
  study_specialties: RegistrationOption[];
  employment_status: RegistrationOption[];
  work_sectors: RegistrationOption[];
}

export const getRegistrationOptions = () =>
  api.get<RegistrationOptions>('/api/users/registration-options');

export const createUser = (data: {
  full_name?: string;
  email?: string;
  age?: number;
  sex?: string;
  native_language?: string;
  english_level?: string;
  english_exposure?: string;
  education_level?: string;
  study_specialty?: string;
  employment_status?: string;
  work_sector?: string;
  daily_writing_practice?: string;
  preferred_language?: 'french' | 'arabic' | 'english';
}) => api.post('/api/users/', data);

export const getUserByEmail = (email: string) =>
  api.get(`/api/users/by-email/${email}`);

export const getUserAttempts = (userId: number) =>
  api.get(`/api/users/${userId}/attempts`);

export const startTest = (data: {
  user_id: number;
  language: 'french' | 'arabic' | 'english';
  test_version: 'A' | 'B' | 'C';
}) => api.post('/api/start-test', data);

export const getNextQuestion = (sessionId: number) =>
  api.get('/api/question/next', { params: { session_id: sessionId } });

export const submitAnswer = (data: {
  session_id: number;
  question_id: number;
  selected_answer: string;
  time_spent_seconds?: number;
}) => api.post('/api/submit-answer', data);

export const navigateQuestion = (data: {
  session_id: number;
  direction: 'back' | 'forward';
}) => api.post('/api/navigate-question', data);

export const completeTest = (attemptId: number) =>
  api.post('/api/complete-test', null, { params: { attempt_id: attemptId } });

export const getResults = (attemptId: number, language: string = 'french') => {
  const url = `/api/results/${attemptId}?language=${language}`;
  console.log(`[API] getResults called with URL: ${url}`);
  return api.get(url);
};

export default api;
